<template>
  <div>
    <div>
        <div>
            <div id="blocklyDiv" style="height: 480px; width: 600px;"></div>

    <xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
      <block type="controls_if"></block>
      <block type="logic_compare"></block>
      <block type="controls_repeat_ext"></block>
      <block type="math_number">
        <field name="NUM">123</field>
      </block>
      <block type="math_arithmetic"></block>
      <block type="text"></block>
      <block type="text_print"></block>
    </xml>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {},
  mounted() {
    var demoWorkspace = Blockly.inject("blocklyDiv", {
      media: "../../static/media/",
      toolbox: document.getElementById("toolbox")
    });
  }
};
</script>
<style lang="">
</style>


// WEBPACK FOOTER //
// src/components/demo.vue